import { ListFilterScreenProps } from "./useFilters";
import _ from "lodash";
import { EnumOperatorPricing } from "gql/generated";
import { useTranslation } from "react-i18next";
import { Checklist } from "shared/components";

export const PricingFilter = ({
  filters,
  onUpdateFilters,
}: ListFilterScreenProps) => {
  const { t } = useTranslation();

  const formattedPricingData = _.sortBy(
    Object.values(EnumOperatorPricing).map((pricing) => ({
      label: t(`core:LOOKUPS.OPERATOR_PRICING.${pricing}`),
      value: pricing,
    })),
    (item) => item.label.toLowerCase(),
  );

  const selectedPricing = filters.pricing;

  const handlePricingSelect = (pricing: string[]) => {
    onUpdateFilters({
      pricing: pricing as EnumOperatorPricing[],
    });
  };
  return (
    <Checklist
      data={formattedPricingData}
      onValueChange={handlePricingSelect}
      value={selectedPricing}
    />
  );
};
